import { render, staticRenderFns } from "./choose-payment-method-step.vue?vue&type=template&id=35cb7286&scoped=true&"
import script from "./choose-payment-method-step.vue?vue&type=script&lang=ts&"
export * from "./choose-payment-method-step.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cb7286",
  null
  
)

export default component.exports